// TODO: Relocate this abstraction once verify info edit is tested out
export default {
  data() {
    return {
      familySameLastName: '',
      familyRemaining: '',
      businessWholeCompany: '',
      multipleAddresses: '',
      moverTypeFamilyModal: false,
      moverTypeBusinessModal: false,
    };
  },
  watch: {
    moverType(currentState, previousState) {
      // DO NOT clear state if previouseState is empty
      if (previousState === '') return;
      // Selected FAMILY, clear BUSINESS questions
      if (currentState === 'FAMILY') {
        this.businessWholeCompany = '';
        this.multipleAddresses = '';
        this.hasRemainingAddressFocus = false;
      }
      // Selected BUSINESS, clear FAMILY questions
      if (currentState === 'BUSINESS') {
        this.familySameLastName = '';
        this.familyRemaining = '';
      }
      // Selected INDIVIDUAL, clear all
      if (!(this.moverTypeFamilyModal || this.moverTypeBusinessModal)) {
        this.familySameLastName = '';
        this.familyRemaining = '';
        this.businessWholeCompany = '';
        this.multipleAddresses = '';
      }
    },
    moverTypeFamilyModal(value) {
      if (value) {
        this.analytics.click.familyModalOpen();
      } else {
        this.analytics.click.familyModalClose();
      }

      // Modal closed, default to INDIVIDUAL and reset questions
      if (!value && this.familyRemaining === 'YES') {
        this.familySameLastName = '';
        this.familyRemaining = '';
      }
    },
    moverTypeBusinessModal(value) {
      if (value) {
        this.analytics.click.businessModalOpen();
      } else {
        this.analytics.click.businessModalClose();
      }

      // Modal closed, default to INDIVIDUAL and reset questions
      if (!value && this.businessWholeCompany === 'NO') {
        this.businessWholeCompany = '';
      }
    },
  },
  methods: {
    familySameLastNameHandle(value) {
      if ((value === 'YES' && this.familyRemaining === 'YES') || value === 'NO') {
        this.moverTypeFamilyModal = true;
      }
    },
    familyRemainingHandle(value) {
      if (value === 'YES') {
        this.moverTypeFamilyModal = true;
        this.moverType = 'INDIVIDUAL';
      }
    },
    businessWholeCompanyHandle(value) {
      if (value === 'NO') {
        this.moverTypeBusinessModal = true;
        this.multipleAddresses = false;
        this.moverType = 'INDIVIDUAL';
      }
    },
  },
};
